export default __webpack_public_path__ + "static/histogram-with-specified-bins-c3b3e131c0288034a20df744b4c79cc5.png";